import React from "react";
import {
  LineChart, Workflow, CreditCard, ShieldCheck, Infinity as InfinityIcon,
  Instagram, Facebook, Twitter, Music2, Send, MessageCircle, Flame, Heart, Star, Sparkles, Lock,
} from "lucide-react";
import { Reveal } from "../lib/motion";
import { TECH, PLATFORMS } from "../data/site";

const ICONS = { LineChart, Workflow, CreditCard, ShieldCheck, Infinity: InfinityIcon };

const PLATFORM_ICONS = {
  OnlyFans: Lock,
  Fansly: Star,
  Fanvue: Sparkles,
  MYM: Sparkles,
  Tinder: Flame,
  Badoo: Heart,
  Bumble: Heart,
  Telegram: Send,
  WhatsApp: MessageCircle,
  Instagram: Instagram,
  Facebook: Facebook,
  TikTok: Music2,
  X: Twitter,
};

export const Technology = () => {
  return (
    <section id="technologia" className="relative py-[clamp(64px,9vw,120px)] bg-surface/30 border-y border-white/10" data-testid="technology-section">
      <div className="container-pm">
        <Reveal className="text-center mb-12">
          <p className="eyebrow mb-4">System w tle</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em]">
            Technologia, która <span className="text-violet-brand">pracuje</span> na Twój sukces.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-16">
          {TECH.map((t, i) => {
            const Icon = ICONS[t.icon];
            return (
              <Reveal key={t.title} delay={i * 0.07}>
                <div className="pm-card card-glow-violet h-full p-6 flex flex-col gap-4">
                  <Icon className="text-violet-brand glow-icon-violet" size={24} strokeWidth={1.6} />
                  <span className="text-sm text-white/80 leading-snug">{t.title}</span>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Platforms marquee */}
        <Reveal>
          <p className="text-center text-xs uppercase tracking-[0.2em] text-white/50 mb-8">
            Działamy tam, gdzie jest uwaga
          </p>
          <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
            <div className="pm-marquee gap-3.5 py-2">
              {[...PLATFORMS, ...PLATFORMS].map((p, i) => {
                const Icon = PLATFORM_ICONS[p] || Sparkles;
                return (
                  <span
                    key={i}
                    className="shrink-0 flex items-center gap-2.5 pl-3 pr-5 py-3 rounded-full border border-white/20 bg-white/[0.07] text-[15px] text-white font-semibold hover:border-coral/60 hover:bg-white/[0.12] transition-colors"
                  >
                    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-coral/20 text-coral">
                      <Icon size={16} strokeWidth={2.2} />
                    </span>
                    {p}
                  </span>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
